module.exports = __webpack_public_path__ + "static/media/image.2f6e69b2.svg";